import { createAction, props } from '@ngrx/store';
import { GroupTag } from '@sleipai/sleip-models';

export const loadGroupTagsForGroup = createAction(
  '[Group Tags] Load Group Tags',
  props<{ groupId: string }>()
);

export const loadGroupTagsForGroupSuccess = createAction(
  '[Group Tags] Load Group Tags Success',
  props<{ groupTags: GroupTag[] }>()
);

export const loadGroupTagsForGroupFailure = createAction(
  '[Group Tags] Load Group Tags Failure',
  props<{ error: any }>()
);